import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder" }, "Credit Balance")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_adjust_balance"
}
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Adjust Balance ")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "card-body pt-0" }, [
  /*#__PURE__*/_createVNode("div", { class: "fw-bolder fs-2" }, [
    /*#__PURE__*/_createTextVNode(" $32,487.57 "),
    /*#__PURE__*/_createVNode("span", { class: "text-muted fs-4 fw-bold" }, "USD"),
    /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-normal text-muted" }, " Balance will increase the amount due on the customer's next invoice. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", {
    class: `card pt-4 ${_ctx.cardClasses}`
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("a", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
          ]),
          _hoisted_6
        ])
      ])
    ]),
    _hoisted_7
  ], 2))
}